import React from 'react';
import { Form } from 'react-final-form';
import { Stack } from '@mui/material';

import { TextField, ConfirmDialog, LinearProgress } from '@occc-app/design-system';

import { validateLocationGroup } from './validation';
import { LocationGroupFormValues } from './types';
import { LocationMultipleSelectField } from './LocationMultipleSelectField';

type LocationGroupCreateDialogProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: LocationGroupFormValues) => void;
  loading: boolean;
};

export const LocationGroupCreateDialog: React.FC<LocationGroupCreateDialogProps> = ({
  open,
  onClose,
  onSubmit,
  loading,
}) => {
  return (
    <Form<LocationGroupFormValues>
      onSubmit={onSubmit}
      validate={validateLocationGroup}
      render={({ handleSubmit, valid }) => {
        return (
          <ConfirmDialog
            dialogTitle='Add a Location Group'
            onClose={onClose}
            open={open}
            maxWidth='sm'
            fullWidth
            confirmButtonText='Add Group'
            confirmButtonProps={{
              onClick: handleSubmit,
              disabled: !valid || loading,
            }}
          >
            {loading && <LinearProgress />}
            <Stack spacing={2} mt={1}>
              <TextField name='name' label='Location Group Name' />
              <LocationMultipleSelectField name='locations' label='Locations' />
            </Stack>
          </ConfirmDialog>
        );
      }}
    />
  );
};
